import { Button, Popconfirm } from 'antd';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';

export function getBankTable(handleAction) {
  return [
    {
      title: 'ID',
      dataIndex: 'bank_id',
      key: 'bank_id',
      sorter: (a, b) => a.bank_id - b.bank_id,
      fixed: 'left',
    },
    {
      title: 'Description',
      dataIndex: 'bank_desc',
      key: 'bank_desc',
      sorter: (a, b) => a.bank_desc.localeCompare(b.bank_desc),
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
    
        <>
          <Button
            type="primary"
            onClick={() => handleAction(record.bank_id, 'edit')}
            icon={<AiFillEdit size={20} />}
            className="mx-2"
          >
            Edit
          </Button>
          <Popconfirm
            title={`Are you sure to delete ${record.bank_desc}?`}
            onConfirm={() => handleAction(record.bank_id, 'delete')}
          >
            <Button type="primary" danger icon={<AiFillDelete size={20} />}>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];
}
